import { render } from "./BuscarPremio.vue?vue&type=template&id=369eb684&scoped=true"
import script from "./BuscarPremio.vue?vue&type=script&lang=js"
export * from "./BuscarPremio.vue?vue&type=script&lang=js"

import "./BuscarPremio.vue?vue&type=style&index=0&id=369eb684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369eb684"]])

export default __exports__